module.exports = __webpack_public_path__ + "img/manage1.2421ac2a.png";